const INITIAL_TIME_DIFF_OBJECT = {
  loadPdf: 0,
  copyPage: 0,
  embedFont: 0,
  draw: 0,
  removePage: 0,
  insertPage: 0,
  savePdfDoc: 0,
  uploadSignatureToUrl: 0,
  saveSignature: 0,
  uploadPdfReportToUrl: 0,
  editPhysicianInterpretation: 0,
  saveSignatureDateToReport: 0,
  uploadPdfReport: 0,
  total: 0,
};

const ADD_SIGNATURE_TIME_TOTAL_LIMIT = 15000;

const REPORT_VERSION = {
  V_2_0_2: '2.0.2',
};

const REPORT_TYPE = {
  EVENT: 'Event',
  NOTIFICATION: 'Notification',
  STUDY: 'Study',
};

const AI_REPORT_LAYOUT_VER100 = {
  INTER_PHYSICIAN_X: 412,
  INTER_PHYSICIAN_BOX_X: 405.5,
  BOX_Y: 566,
  BOX_WIDTH: 197,
  BOX_HEIGHT: 83,
  PHYSICIAN_BASE_Y: 634,
  ROW_HEIGHT: 17,
  MAX_TEXT_WIDTH: 180,
  MAX_ADDRESS_LINES: 2,
  MAX_NAME_LINES: 2,
};

const AI_REPORT_LAYOUT = {
  INTER_PHYSICIAN_BOX_X: 403.5,
  INTER_PHYSICIAN_X: 410,
  BOX_Y: 549,
  BOX_WIDTH: 193,
  BOX_HEIGHT: 88,
  PHYSICIAN_BASE_Y: 622.4,
  ROW_HEIGHT: 18,
  MAX_TEXT_WIDTH: 180,
  MAX_ADDRESS_LINES: 2,
  MAX_NAME_LINES: 2,
};

const EOU_REPORT_LAYOUT = {
  INTER_PHYSICIAN_BOX_X: 453,
  BOX_Y: 499.2,
  BOX_WIDTH: 144,
  BOX_HEIGHT: 131,
  INTER_PHYSICIAN_X: 459,
  PHYSICIAN_BASE_Y: 616,
  ROW_HEIGHT: 17,
  MAX_TEXT_WIDTH: 130,
  MAX_ADDRESS_LINES: 4,
  MAX_NAME_LINES: 4,
};

const EOU_REPORT_LAYOUT_VER200 = {
  INTER_PHYSICIAN_BOX_X: 453,
  BOX_Y: 513,
  BOX_WIDTH: 144,
  BOX_HEIGHT: 124,
  INTER_PHYSICIAN_X: 459,
  PHYSICIAN_BASE_Y: 623.5,
  ROW_HEIGHT: 16.5,
  MAX_TEXT_WIDTH: 130,
  MAX_ADDRESS_LINES: 4,
  MAX_NAME_LINES: 4,
};

export {
  ADD_SIGNATURE_TIME_TOTAL_LIMIT,
  INITIAL_TIME_DIFF_OBJECT,
  REPORT_VERSION,
  REPORT_TYPE,
  AI_REPORT_LAYOUT,
  AI_REPORT_LAYOUT_VER100,
  EOU_REPORT_LAYOUT,
  EOU_REPORT_LAYOUT_VER200,
};
